module.exports = __webpack_public_path__ + "img/arkmanduyuru.a2f744e7.jpeg";